<template>
    <div
        class="modal add-card-modal"
        aria-labelledby="add-user-modal-title"
        role="dialog"
        aria-modal="true"
        v-show="showAddUserModal"
    >
        <div class="modal-overlay" aria-hidden="true"></div>
        <div
            class="modal-wrapper bg-white relative flex flex-col z-50 overflow-hidden rounded-lg box-shadow-lg transition-all my-50 mx-auto w-128"
        >
            <a
                href="#"
                class="modal-close-btn"
                role="button"
                @click.prevent="close"
                id="hs-wallet-close-add-user-modal"
            >
                <i class="fal fa-times"></i>
            </a>
            <header
                class="modal-header items-start p-2 bg-white border-t-4 border-solid border-t-orange rounded-t-lg"
            ></header>
            <div class="modal-body flex !flex-row !items-start px-5 w-full">
                <div class="flex h-16 w-16 justify-center mr-5">
                    <img src="/images/users.svg" />
                </div>
                <div class="ml-2">
                    <h3
                        class="mb-5 text-1xl md:text-2xl text-gray-800 font-bold"
                        id="add-user-modal-title"
                    >
                        Add User Account & Wallet
                    </h3>
                    <div class="text-sm mb-5">
                        <div class="text-gray-800 text-base mb-3">
                            Have a Player 2, or even 3 or 4? My10x makes it easy
                            for you to manage multiple users:
                        </div>
                        <ul class="mb-8">
                            <li class="flex items-center mb-1">
                                <svg
                                    class="w-3 h-3 shrink-0 text-orange fill-current mr-2"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z"
                                    ></path>
                                </svg>
                                <div>
                                    Create a separate wallet for each user
                                </div>
                            </li>

                            <li class="flex items-center mb-1">
                                <svg
                                    class="w-3 h-3 shrink-0 text-orange fill-current mr-2"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z"
                                    ></path>
                                </svg>
                                <div>
                                    Easily track each user's eligibility for new
                                    products
                                </div>
                            </li>

                            <li class="flex items-center mb-1">
                                <svg
                                    class="w-3 h-3 shrink-0 text-orange fill-current mr-2"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z"
                                    ></path>
                                </svg>
                                <div>
                                    At a quick glance, know how many points each
                                    user has across various loyalty programs
                                </div>
                            </li>

                            <li class="flex items-center mb-1">
                                <svg
                                    class="w-3 h-3 shrink-0 text-orange fill-current mr-2"
                                    viewBox="0 0 12 12"
                                >
                                    <path
                                        d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z"
                                    ></path>
                                </svg>
                                <div>
                                    There are no limits to how many wallets you
                                    can manage
                                </div>
                            </li>
                        </ul>
                    </div>
                    <label>
                        <span class="text-sm mb-2 block">
                            Enter the email of the user below to invite them to
                            create an account and share their wallet with you.
                        </span>
                        <input
                            type="email"
                            class="form-input w-96"
                            v-model="email"
                            placeholder="Email Address"
                        />
                    </label>
                    <Errors :errors="errors" class="mt-3" />
                </div>
            </div>
            <footer
                class="modal-footer !flex-row justify-end gap-2 items-center bg-gray-50"
            >
                <button
                    type="button"
                    class="btn-base btn-white "
                    @click.prevent="close"
                    id="hs-wallet-close-add-user-modal"
                >
                    Close
                </button>

                <ActionButton
                    @clicked="addUser"
                    label="Invite User"
                    :loading="addUserBtnAction"
                    classes="btn-base btn-dark"
                    buttonId="hs-wallet-add-user-submit"
                />
            </footer>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useWalletStore } from '@/store/wallet';
import ActionButton from '@/components/action-button.vue';
import Errors from '@/components/errors.vue';

export default {
    name: 'AddWalletUserModal',
    props: {
        localwallet: {
            type: Number,
            default: 0,
        },
        refreshview: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ActionButton,
        Errors,
    },
    data: () => ({
        addUserBtnAction: false,
        email: '',
        errors: [],
    }),
    computed: {
        ...mapState(useWalletStore, ['wallet', 'showAddUserModal']),
    },
    methods: {
        ...mapActions(useWalletStore, ['setShowAddUserModal']),
        addUser() {
            this.errors = [];
            this.addUserBtnAction = true;

            const re =
                /^([\w\+\-]+(?:\.[\w\+\-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            let validEmail = re.test(this.email);

            if (this.email.length === 0 || !validEmail) {
                this.$notify(
                    {
                        group: 'error',
                        title: 'Error',
                        text: 'Please enter a valid email.',
                    },
                    4000
                );
                this.addUserBtnAction = false;
            } else {
                let data = {
                    email: this.email,
                };

                const walletId = this.localwallet
                    ? this.localwallet
                    : this.wallet.id;

                ApiService.apiCall(
                    '/wallets/' + walletId + '/users',
                    'post',
                    data
                )
                    .then((response) => {
                        this.$notify(
                            {
                                group: 'success',
                                title: 'Success',
                                text: 'User invited.',
                            },
                            4000
                        );
                        if (import.meta.env.VITE_APP_ENV === 'production') {
                            woopra.track('wallet-user-added-my10x', {
                                email: this.email,
                                uuid: localStorage.getItem('uuid'),
                            });
                        }
                        this.addUserBtnAction = false;
                        this.$emit('addedUser');

                        if (this.refreshview) {
                            location.reload();
                        }

                        setTimeout(() => {
                            this.close();
                            this.email = '';
                        }, 300);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.errors.push({
                            message: response.response.data.message,
                        });
                        this.$root.handleHttpStatus(response);
                        this.addUserBtnAction = false;
                    });
            }
        },
        close() {
            this.setShowAddUserModal(false);
        },
    },
    created() {},
    mounted() {},
};
</script>
